const PostContentText = ({ text }) => {
  const normalizedData = {
    text,
  }

  return normalizedData
}

export default PostContentText
